import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-general-folder-icon',
  templateUrl: './general-folder.component.html'
})
export class GeneralFolderComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
